import React from "react";
import { Box, ButtonBase, Skeleton, Typography } from "@mui/material";
import PlayerHeadshot from "../PlayerHeadshot";
import { homeCardHover, horizontalScroll } from "../home/homeStyles";
import { colors } from "../../theme";

const FeaturedPlayerTile = ({ player, onSelect }) => (
  <ButtonBase
    onClick={() => onSelect?.(player.playerId)}
    aria-label={`${player.name}, ${player.statLabel} ${player.statValue}`}
    sx={{
      minWidth: 140,
      maxWidth: 140,
      flex: "0 0 auto",
      p: 1.5,
      borderRadius: 1.5,
      border: `1px solid ${colors.border}`,
      display: "block",
      textAlign: "center",
      ...homeCardHover,
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
      <PlayerHeadshot
        playerId={player.playerId}
        sport={player.sport}
        size={56}
        showTooltip={false}
        showLoading={false}
      />
    </Box>
    <Typography
      variant="body2"
      fontWeight={600}
      noWrap
      title={player.name}
    >
      {player.name}
    </Typography>
    {player.subtitle ? (
      <Typography
        variant="caption"
        color="text.secondary"
        noWrap
        display="block"
      >
        {player.subtitle}
      </Typography>
    ) : null}
    <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
      {player.statLabel}
    </Typography>
    <Typography variant="h6" fontWeight={700} color="primary.main" lineHeight={1.2}>
      {player.statValue}
    </Typography>
  </ButtonBase>
);

const FeaturedPlayerTiles = ({
  players = [],
  loading = false,
  onSelect,
}) => {
  if (loading && players.length === 0) {
    return (
      <Box sx={{ ...horizontalScroll, p: 2 }}>
        {[1, 2, 3, 4, 5].map((key) => (
          <Skeleton
            key={key}
            variant="rounded"
            width={140}
            height={180}
            sx={{ flexShrink: 0 }}
          />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ ...horizontalScroll, p: 2 }}>
      {players.map((player) => (
        <FeaturedPlayerTile
          key={player.playerId}
          player={player}
          onSelect={onSelect}
        />
      ))}
    </Box>
  );
};

export default FeaturedPlayerTiles;
